import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center py-20 px-4 text-center">
      {/* 404 Number */}
      <div className="relative mb-8 mt-20">
        <div className="text-[150px] font-bold text-gray-100 leading-none">404</div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-3xl text-[#FF4444] font-bold">
          Page Not Found
        </div>
      </div>
      
      {/* Message and simple text instead of illustration */}
      <div className="max-w-md mx-auto mb-10">
        <p className="text-gray-600 mb-6">
          The page you're looking for doesn't exist or has been moved.
        </p>
        
       
        
        {/* Action buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link 
            to="/" 
            className="px-6 py-3 bg-[#FF4444] text-white rounded-md font-medium hover:bg-[#FF2222] transition-colors"
          >
            Back to Home
          </Link>
          <Link 
            to="/dashboard" 
            className="px-6 py-3 bg-white border border-gray-300 text-gray-700 rounded-md font-medium hover:bg-gray-50 transition-colors"
          >
            Go to Dashboard
          </Link>
        </div>
      </div>
      
      {/* Support link */}
      <p className="text-sm text-gray-500">
        Need help? <a href="mailto:support@ourphotos.co" className="text-[#FF4444] hover:underline">Contact Support</a>
      </p>
    </div>
  );
};

export default NotFound; 